import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import GalleryPic from "../../Components/gallery/gallery";
import {Button, Card} from "react-bootstrap";

const imageUrls = [
    'https://stahl-taucher.de/Galerie/Meer/images/001.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/002.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/003.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/004.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/005.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/006.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/007.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/008.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/009.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/010.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/011.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/012.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/013.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/014.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/015.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/016.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/017.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/018.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/019.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/020.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/021.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/022.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/023.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/024.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/025.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/026.jpg',
    'https://stahl-taucher.de/Galerie/Meer/images/027.jpg',];

function GalleryPageMeer() {

    return (<>
            <Navbar/>
            <Card>
                <Card.Header><Card.Title>Meeres Galerie</Card.Title></Card.Header>
                <GalleryPic urls={imageUrls}/>
            </Card>
            <Card className="impressum">
                <Button variant="Link" href="/kontakt">Impressum</Button>
            </Card>
        </>


    )

}

export default GalleryPageMeer;